import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useTranslation } from "react-i18next";
import { getFNSLocale } from "localization/i18n";

/**
 * Application wide localization provider for MUI date/time pickers. Keeps the
 * picker locale in sync with the active i18next language.
 */
export const NorreLocalizationProvider = ({
    children,
}: {
    children: React.ReactNode;
}) => {
    const { i18n } = useTranslation();
    return (
        <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={getFNSLocale(i18n.language)}
        >
            {children}
        </LocalizationProvider>
    );
};
